export enum EqualityChecksResult {
    BOTH_EQUAL = 'equal',
    BOTH_NOT_EQUAL = 'both not equal',
    CLOSING_NOT_EQUAL = 'closing not equal',
    OPENING_NOT_EQUAL = 'opening not equal',
}
